import { render, staticRenderFns } from "./order-goods.vue?vue&type=template&id=80e11864&scoped=true&"
import script from "./order-goods.vue?vue&type=script&lang=js&"
export * from "./order-goods.vue?vue&type=script&lang=js&"
import style0 from "./order-goods.vue?vue&type=style&index=0&id=80e11864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e11864",
  null
  
)

export default component.exports